import React, { useState, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import useAuth from "../../hooks/useAuth";
import api from "../../Api/api";
import { useMutation } from "@tanstack/react-query";

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [submenuState, setSubmenuState] = useState({
    moving: false,
    logistics: false,
  });
  const [headerHeight, setHeaderHeight] = useState(0);
  const { auth, setAuth } = useAuth();
  const navigate = useNavigate();
  const cartreduxdata = useSelector((state) => state.cart);

  const mutationlogout = useMutation(
    (body) => {
      const authstring = auth.token ?? auth.user.refreshtoken;
      const headers = {
        headers: {
          authorization: "bearer " + authstring,
        },
      };
      return api.post("admin/logout", body, headers);
    },
    {
      onSuccess: () => {
        localStorage.clear();
        setAuth({});
        window.location.reload();
        navigate("/");
      },
      onError: (error) => {
        console.log(error);
      },
    }
  );

  useEffect(() => {
    if (localStorage.getItem("token")) {
      setAuth({ token: localStorage.getItem("token") });
    }
  }, []);

  const handleLogout = () => {
    mutationlogout.mutate({ token: auth.token ?? auth.user.refreshtoken });
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
    document.body.classList.toggle("sidebar-open", !menuOpen);
  };

  const toggleSubmenu = (menu) => {
    if (window.innerWidth < 767) {
      setSubmenuState((prev) => ({
        ...prev,
        [menu]: !prev[menu],
      }));
    }
  };

  useEffect(() => {
    const headerEl = document.querySelector(".header");
    if (headerEl) setHeaderHeight(headerEl.offsetHeight);

    const handleResize = () => {
      const isMobile = window.innerWidth < 767;
      if (!isMobile) {
        setMenuOpen(false);
        setSubmenuState({ moving: false, logistics: false });
        document.body.classList.remove("sidebar-open");
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {/* DESKTOP HEADER */}
      <header className="main-header">
        <div className="top-header">
          <div className="number">
            <a href="#"><i className="fas fa-phone"></i> 02039277675</a>
            <a href="#"><i className="fas fa-envelope"></i> contact@southlondonremovals.uk</a>
          </div>
          <div className="links">
            <a target="_blank" href="https://www.facebook.com/southlondonremovalsltd/"><i className="fab fa-facebook-f"></i></a>
            <a target="_blank" href="https://www.instagram.com/southlondonremovals/"><i className="fab fa-instagram"></i></a>
            <a target="_blank" href="https://www.youtube.com/@southlondonremovalsltd"><i className="fab fa-youtube"></i></a>
            <a target="_blank" href="https://www.tiktok.com/@southlondoneremovals?_t=ZS-8uvWw63JkvZ&_r=1"><i className="fab fa-tiktok"></i></a>
            <a target="_blank" href="https://www.linkedin.com/company/south-london-removals1/"><i className="fab fa-linkedin"></i></a>
            {/* <a target="_blank" href="https://www.google.com/search?sa=X&sca_esv=d81d33885b31fd73&rlz=1C5CHFA_enIN1040IN1040&biw=1470&bih=718&sxsrf=AE3TifOwiKdQzYjzBd2ZhncfAx-Wq85vWA%3A1753985913530&kgmid=%2Fg%2F11s4bwtd8m&q=South%20London%20Removals&shndl=30&shem=lcuae%2Clsptb1%2Csdl1pl%2Cuaasie&source=sh%2Fx%2Floc%2Funi%2Fm1%2F1&kgs=62f953dc4642afba"><i className="fab fa-google"></i></a> */}
          </div>
        </div>

        <nav className="nav-two">
          <div className="logo2">
            <a href="https://southlondonremovals.uk/"><img src="https://southlondonremovals.uk/images/logo.png" alt="Logo" /></a>
          </div>
          <ul className="menu">
            <li><a href="https://southlondonremovals.uk/">Home</a></li>

            <li className="menu-item has-submenu">
              <a href="#">Moving</a>
              <ul className="submenu">
                <li><a href="https://southlondonremovals.uk/home-removals-london/">UK Home Moves</a></li>
                <li><a href="https://southlondonremovals.uk/business-movers-london/">UK Business Moves</a></li>
                <li><a href="https://southlondonremovals.uk/international-movers/">International Moves</a></li>
              </ul>
            </li>

            <li className="menu-item has-submenu">
              <a href="#">Logistics</a>
              <ul className="submenu">
                <li><a href="https://southlondonremovals.uk/furniture-removals-london/">Furniture Delivery</a></li>
                <li><a href="https://southlondonremovals.uk/pallet-delivery-london/">Pallet Delivery</a></li>
                <li><a href="https://southlondonremovals.uk/european-removals-london/">European Haulage</a></li>
                <li><a href="https://southlondonremovals.uk/container-removals-london/">Container Transport</a></li>
                <li><a href="https://southlondonremovals.uk/express-delivery-london/">Express Delivery</a></li>
                <li><a href="https://southlondonremovals.uk/cargo/">Cargo</a></li>
              </ul>
            </li>

            <li><a href="https://southlondonremovals.uk/storage-services-london/">Storage</a></li>
            <li><a href="https://packing-material.southlondonremovals.uk/">Packing Materials</a></li>
            <li><a href="https://southlondonremovals.uk/contact-us/">Contact Us</a></li>
          </ul>
        </nav>
      </header>

      {/* MOBILE NAV */}
      <div className="mobilenavv">
        <header className="header">
          <div className="container">
            <div className="row-wrap">
              <div className="logo-wrap">
                <span className="logo">
                  <a href="https://southlondonremovals.uk/">
                  <img src="https://southlondonremovals.uk/images/logo.png" alt="Logo" />
                  </a>
                </span>
              </div>

              <div
                className={`nav-wrap ${menuOpen ? "is-open" : ""}`}
                style={{
                  paddingTop: window.innerWidth < 767 ? `${headerHeight}px` : "0",
                }}
              >
                <div className="s-logo-section">
                  <img src="https://southlondonremovals.uk/images/logo.png" alt="Logo" className="s-logo" />
                </div>
                <ul className="nav-list">

                  <li>
                    <a href="https://southlondonremovals.uk/">Home</a>
                  </li>

                  <li
                    className={`with-submenu ${submenuState.moving ? "is-open" : ""}`}
                    onClick={() => toggleSubmenu("moving")}
                  >
                    <a href="#">Moving</a>
                    <div
                      className="submenu"
                      style={{
                        display: window.innerWidth < 767 && !submenuState.moving ? "none" : "block",
                      }}
                    >
                      <ul className="submenu-inner">
                        <li><a href="https://southlondonremovals.uk/home-removals-london/">UK Home Moves</a></li>
                        <li><a href="https://southlondonremovals.uk/business-movers-london/">UK Business Moves</a></li>
                        <li><a href="https://southlondonremovals.uk/international-movers/">International Moves</a></li>
                      </ul>
                    </div>
                  </li>

                  <li
                    className={`with-submenu ${submenuState.logistics ? "is-open" : ""}`}
                    onClick={() => toggleSubmenu("logistics")}
                  >
                    <a href="#">Logistics</a>
                    <div
                      className="submenu"
                      style={{
                        display: window.innerWidth < 767 && !submenuState.logistics ? "none" : "block",
                      }}
                    >
                      <ul className="submenu-inner">
                        <li><a href="https://southlondonremovals.uk/furniture-removals-london/">Furniture Delivery</a></li>
                        <li><a href="https://southlondonremovals.uk/pallet-delivery-london/">Pallet Delivery</a></li>
                        <li><a href="https://southlondonremovals.uk/european-removals-london/">European Haulage</a></li>
                        <li><a href="https://southlondonremovals.uk/container-removals-london/">Container Transport</a></li>
                        <li><a href="https://southlondonremovals.uk/express-delivery-london/">Express Delivery</a></li>
                        <li><a href="https://southlondonremovals.uk/cargo/">Cargo</a></li>
                      </ul>
                    </div>
                  </li>

                  <li><a href="https://southlondonremovals.uk/storage-services-london/">Storage</a></li>
                  <li><a href="https://packing-material.southlondonremovals.uk/">Packing Materials</a></li>
                  <li><a href="https://southlondonremovals.uk/contact-us/">Contact Us</a></li>
                </ul>

                <div className="links d-flex">
                    <a target="_blank" href="https://www.facebook.com/southlondonremovalsltd/"><i className="fab fa-facebook-f"></i></a>
            <a target="_blank" href="https://www.instagram.com/southlondonremovals/"><i className="fab fa-instagram"></i></a>
            <a target="_blank" href="https://www.youtube.com/@southlondonremovalsltd"><i className="fab fa-youtube"></i></a>
            <a target="_blank" href="https://www.tiktok.com/@southlondoneremovals?_t=ZS-8uvWw63JkvZ&_r=1"><i className="fab fa-tiktok"></i></a>
            <a target="_blank" href="https://www.linkedin.com/company/south-london-removals1/"><i className="fab fa-linkedin"></i></a>
            
            {/* <a target="_blank" href="https://www.google.com/search?sa=X&sca_esv=d81d33885b31fd73&rlz=1C5CHFA_enIN1040IN1040&biw=1470&bih=718&sxsrf=AE3TifOwiKdQzYjzBd2ZhncfAx-Wq85vWA%3A1753985913530&kgmid=%2Fg%2F11s4bwtd8m&q=South%20London%20Removals&shndl=30&shem=lcuae%2Clsptb1%2Csdl1pl%2Cuaasie&source=sh%2Fx%2Floc%2Funi%2Fm1%2F1&kgs=62f953dc4642afba"><i className="fab fa-google"></i></a> */}
                  </div>
              </div>

              <div
                className={`hamburger ${menuOpen ? "is-active" : ""}`}
                onClick={toggleMenu}
              >
                <span className="line"></span>
                <span className="line"></span>
                <span className="line"></span>
              </div>
            </div>
          </div>
        </header>
        <div className="overlay" onClick={toggleMenu}></div>
      </div>

      <ToastContainer />
    </>
  );
}

export default Header;